// Auto-generated by scripts/generate-glossary.ts - DO NOT EDIT MANUALLY

import type { GlossaryEntry, GlossaryId } from '~/generated/glossary.types';

export const GLOSSARY = {
  "A Good Night’s Rest (~6-8 hours of sleep)": {
    id: "A Good Night’s Rest (~6-8 hours of sleep)",
    name: ["A Good Night’s Rest (~6-8 hours of sleep)","Full Rest","Good Night's Rest","Good Night’s Rest"],
    allNames: ["A Good Night’s Rest (~6-8 hours of sleep)","Full Rest","Good Night's Rest","Good Night’s Rest"],
    type: "term",
    category: 'general',
    content: "You Recover all Resilience, remove all accumulated Strain, and roll a [Resilience Check] to recover Health Points.\nYou must have food, water, and safety to sleep.",
    refs: ['Health Points', 'Resilience', 'Resilience Check', 'Strain'],
    referencedBy: [],
    sources: ["5_RESTING"],
    metadata: {},
  },
  "Accuracy": {
    id: "Accuracy",
    name: ["Accuracy"],
    allNames: ["Accuracy"],
    type: "Skill Check",
    category: 'general',
    content: "Can you hit it? — Calculated as **Mind** + **Mind** + **Body**.",
    refs: ['Body', 'Hit', 'Mind'],
    referencedBy: ['Dodge Action', 'Flinch Action'],
    sources: ["3.1_STAT_CHECKS"],
    metadata: {"tags":"stat, skill, rollable","formula":"Mind + Mind + Body"},
  },
  "Acrobatics": {
    id: "Acrobatics",
    name: ["Acrobatics"],
    allNames: ["Acrobatics"],
    type: "Skill Check",
    category: 'general',
    content: "Can you jump over it? — Calculated as **Body** + **Reflex**.",
    refs: ['Body', 'Reflex'],
    referencedBy: [],
    sources: ["3.1_STAT_CHECKS"],
    metadata: {"tags":"stat, skill, rollable","formula":"Body + Reflex"},
  },
  "Body": {
    id: "Body",
    name: ["Body"],
    allNames: ["Body"],
    type: "Core Stat",
    category: 'general',
    content: "**Body** represents your character's physical strength, toughness, and endurance.",
    refs: ['Strength'],
    referencedBy: ['Accuracy', 'Acrobatics', 'Dodge', 'Health Points', 'Movement Speed', 'Resilience', 'Resilience Check', 'Strength'],
    sources: ["2_CHARACTER_CREATION"],
    metadata: {"tags":"stat, core, rollable"},
  },
  "Breather Action": {
    id: "Breather Action",
    name: ["Breather Action"],
    allNames: ["Breather Action"],
    type: "term",
    category: 'general',
    content: "Take a breather and regain your composure. This immediately ends your turn.\n\nWhen taking a breather you may choose as many of the following effects as you wish. However, you accumulate [1 Strain] for each action you choose.\n\n- Roll [Resilience] and Recover **Resilience** equal to the hits + 1.\n- Recover **Resilience** equal to your **Mind** stat (minimum 1).\n\n> ⚠️ When combat ends, for every 2 Strain you have accumulated, take 1 point of damage directly to your Health, bypassing your Resilience. This does not clear the [Strain] you have accumulated.",
    refs: ['Mind', 'Resilience', 'Strain', 'Turn'],
    referencedBy: [],
    sources: ["4_COMBAT"],
    metadata: {"tags":"action, combat"},
  },
  "Complex Action": {
    id: "Complex Action",
    name: ["Complex Action"],
    allNames: ["Complex Action","Complex"],
    type: "action",
    category: 'combat',
    content: "In general, an action which takes more than one roll to complete.",
    refs: [],
    referencedBy: ['Turn'],
    sources: ["4_COMBAT"],
    metadata: {},
  },
  "Contested Check": {
    id: "Contested Check",
    name: ["Contested Check","CC"],
    allNames: ["Contested Check","CC"],
    type: "check",
    category: 'general',
    content: "A contested check is between you and another character; one being the attacker (the one who wants to do something), the other being the defender (the one who wants to prevent something). In a contested check, the defender's hits are subtracted from the attacker's hits. The remaining hits are then used in the Difficulty check or Proficiency check.",
    refs: ['Difficulty Check', 'Proficiency Check'],
    referencedBy: [],
    sources: ["3.1_STAT_CHECKS"],
    metadata: {"tags":"check"},
  },
  "Critical Fumble": {
    id: "Critical Fumble",
    name: ["Critical Fumble"],
    allNames: ["Critical Fumble"],
    type: "term",
    category: 'dice',
    content: "A **critical fumble** (or **crit fumble**) happens when you **fumble** and 50% or more of your dice show 1.",
    refs: ['Fumble'],
    referencedBy: ['Proficiency Check'],
    sources: [],
    metadata: {"critFumbleThreshold":"0.5"},
  },
  "Difficulty Check": {
    id: "Difficulty Check",
    name: ["Difficulty Check","DC"],
    allNames: ["Difficulty Check","DC"],
    type: "check",
    category: 'general',
    content: "To succeed on a difficulty check you must roll enough hits to either meet or exceed the difficulty set by the GM.",
    refs: [],
    referencedBy: ['Contested Check'],
    sources: ["3.1_STAT_CHECKS"],
    metadata: {"tags":"check"},
  },
  "Dodge": {
    id: "Dodge",
    name: ["Dodge"],
    allNames: ["Dodge"],
    type: "Skill Check",
    category: 'general',
    content: "Can you avoid it? — Calculated as **Body** + **Reflex** + **Reflex**.",
    refs: ['Body', 'Reflex'],
    referencedBy: ['Dodge Action'],
    sources: ["3.1_STAT_CHECKS"],
    metadata: {"tags":"stat, skill, rollable","formula":"Body + Reflex + Reflex"},
  },
  "Dodge Action": {
    id: "Dodge Action",
    name: ["Dodge Action"],
    allNames: ["Dodge Action"],
    type: "term",
    category: 'general',
    content: "Once between your turns when you are targeted, you may choose to Dodge instead of taking the free Flinch action.\n\nRoll your Dodge stat to contest the accuracy check. \n\nIf the accuracy check targeting you fails because of this, they are interrupted, you steal their initiative pick and their turn ends immediately.",
    refs: ['Accuracy', 'Dodge', 'Flinch Action', 'Turn'],
    referencedBy: [],
    sources: ["4_COMBAT"],
    metadata: {"tags":"action, combat"},
  },
  "Flinch Action": {
    id: "Flinch Action",
    name: ["Flinch Action"],
    allNames: ["Flinch Action"],
    type: "term",
    category: 'general',
    content: "Whenever you are targeted, you may roll your **reflex** stat to contest an **accuracy** check. Subtracting your **hits** from the **accuracy** check targeting you.",
    refs: ['Accuracy', 'Reflex'],
    referencedBy: ['Dodge Action'],
    sources: ["4_COMBAT"],
    metadata: {"tags":"action, combat"},
  },
  "Fumble": {
    id: "Fumble",
    name: ["Fumble"],
    allNames: ["Fumble"],
    type: "term",
    category: 'dice',
    content: "A **fumble** occurs when you roll a pool of dice and score zero **hits**.",
    refs: [],
    referencedBy: ['Critical Fumble', 'Proficiency Check'],
    sources: [],
    metadata: {},
  },
  "Health Points": {
    id: "Health Points",
    name: ["Health Points","HP"],
    allNames: ["Health Points","HP","Health"],
    type: "Derived Stat",
    category: 'general',
    content: "Your health points represent how much lasting damage you can take before becoming incapacitated and risking death.\n\nCalculated as **Body** + **Body** + 3.",
    refs: ['Body'],
    referencedBy: ['A Good Night’s Rest (~6-8 hours of sleep)'],
    sources: ["2_CHARACTER_CREATION"],
    metadata: {"tags":"stat, derived, tracked","formula":"Body + Body + 3"},
  },
  "Hit": {
    id: "Hit",
    name: ["Hit"],
    allNames: ["Hit"],
    type: "term",
    category: 'dice',
    content: "A **hit** is scored when a die shows 5 or 6.",
    refs: [],
    referencedBy: ['Accuracy'],
    sources: [],
    metadata: {"hitThreshold":"5","dieType":"6"},
  },
  "Instant Action": {
    id: "Instant Action",
    name: ["Instant Action"],
    allNames: ["Instant Action","Instant"],
    type: "action",
    category: 'combat',
    content: "An action which can be taken outside of your turn, usually in reaction to something happening.",
    refs: ['Turn'],
    referencedBy: [],
    sources: ["4_COMBAT"],
    metadata: {},
  },
  "Knowledge": {
    id: "Knowledge",
    name: ["Knowledge"],
    allNames: ["Knowledge"],
    type: "Skill Check",
    category: 'general',
    content: "Can you remember it? — Calculated as **Mind** + **Mind**.",
    refs: ['Mind'],
    referencedBy: [],
    sources: ["3.1_STAT_CHECKS"],
    metadata: {"tags":"stat, skill, rollable","formula":"Mind + Mind"},
  },
  "Meal Break (~1 hour)": {
    id: "Meal Break (~1 hour)",
    name: ["Meal Break (~1 hour)","Meal Break"],
    allNames: ["Meal Break (~1 hour)","Meal Break"],
    type: "term",
    category: 'general',
    content: "Recover all Resilience, and remove all accumulated Strain.\nYou must have food, water, and safety to take a meal break.",
    refs: ['Resilience', 'Strain'],
    referencedBy: [],
    sources: ["5_RESTING"],
    metadata: {},
  },
  "Mind": {
    id: "Mind",
    name: ["Mind"],
    allNames: ["Mind"],
    type: "Core Stat",
    category: 'general',
    content: "**Mind** represents your character's mental acuity, intelligence, and force of will.",
    refs: [],
    referencedBy: ['Accuracy', 'Breather Action', 'Knowledge', 'Perception', 'Resilience', 'Resilience Check', 'Stealth'],
    sources: ["2_CHARACTER_CREATION"],
    metadata: {"tags":"stat, core, rollable"},
  },
  "Movement Speed": {
    id: "Movement Speed",
    name: ["Movement Speed"],
    allNames: ["Movement Speed","Movement"],
    type: "Derived Stat",
    category: 'general',
    content: "Your movement speed determines how far you can travel in combat.\n\nCalculated as **Body** + **Reflex** + 3.",
    refs: ['Body', 'Reflex'],
    referencedBy: [],
    sources: ["2_CHARACTER_CREATION"],
    metadata: {"tags":"stat, derived","formula":"Body + Reflex + 3"},
  },
  "Perception": {
    id: "Perception",
    name: ["Perception"],
    allNames: ["Perception"],
    type: "Skill Check",
    category: 'general',
    content: "Can you sense it? — Calculated as **Mind** + **Mind** + **Reflex**.",
    refs: ['Mind', 'Reflex'],
    referencedBy: [],
    sources: ["3.1_STAT_CHECKS"],
    metadata: {"tags":"stat, skill, rollable","formula":"Mind + Mind + Reflex"},
  },
  "Proficiency Check": {
    id: "Proficiency Check",
    name: ["Proficiency Check","PC"],
    allNames: ["Proficiency Check","PC"],
    type: "check",
    category: 'general',
    content: "These are used for movement and other tasks your character is already good at and are generally more fun narratively. The more hits your roll, the better you did! The only way to fail a proficiency check is to roll a fumble or critical fumble.",
    refs: ['Critical Fumble', 'Fumble'],
    referencedBy: ['Contested Check'],
    sources: ["3.1_STAT_CHECKS"],
    metadata: {"tags":"check"},
  },
  "Reflex": {
    id: "Reflex",
    name: ["Reflex"],
    allNames: ["Reflex"],
    type: "Core Stat",
    category: 'general',
    content: "**Reflex** represents your character's speed, agility, and reaction time.",
    refs: [],
    referencedBy: ['Acrobatics', 'Dodge', 'Flinch Action', 'Movement Speed', 'Perception', 'Stealth'],
    sources: ["2_CHARACTER_CREATION"],
    metadata: {"tags":"stat, core, rollable"},
  },
  "Resilience": {
    id: "Resilience",
    name: ["Resilience"],
    allNames: ["Resilience"],
    type: "Derived Stat",
    category: 'general',
    content: "Your resilience represents your capacity to absorb stress and avoid lasting harm. \nWhether that's stress from receiving an attack or pushing your body to its limit from using special abilities.\n\nDamage you take reduces your **resilience** first.\nWhen you run out of **resilience**, any further damage you take is applied directly to your health.\n\nCalculated as **Mind** + **Body**.",
    refs: ['Body', 'Mind'],
    referencedBy: ['A Good Night’s Rest (~6-8 hours of sleep)', 'Breather Action', 'Meal Break (~1 hour)', 'Snack Break (~15 minutes)', 'Strain Damage'],
    sources: ["2_CHARACTER_CREATION"],
    metadata: {"tags":"stat, derived, tracked","formula":"Mind + Body"},
  },
  "Resilience Check": {
    id: "Resilience Check",
    name: ["Resilience Check"],
    allNames: ["Resilience Check"],
    type: "Skill Check",
    category: 'general',
    content: "Can you resist it? — Calculated as **Mind** + **Body**.",
    refs: ['Body', 'Mind'],
    referencedBy: ['A Good Night’s Rest (~6-8 hours of sleep)'],
    sources: ["3.1_STAT_CHECKS"],
    metadata: {"tags":"stat, skill, rollable","formula":"Mind + Body"},
  },
  "Simple Action": {
    id: "Simple Action",
    name: ["Simple Action"],
    allNames: ["Simple Action","Simple"],
    type: "action",
    category: 'combat',
    content: "In general, a quick action which takes one or no rolls to complete.",
    refs: [],
    referencedBy: ['Turn'],
    sources: ["4_COMBAT"],
    metadata: {},
  },
  "Snack Break (~15 minutes)": {
    id: "Snack Break (~15 minutes)",
    name: ["Snack Break (~15 minutes)","Snack Break"],
    allNames: ["Snack Break (~15 minutes)","Snack Break"],
    type: "term",
    category: 'general',
    content: "Recover 2 Resilience and remove 1 Strain.\nYou must have food and water to take a snack break.",
    refs: ['Resilience', 'Strain'],
    referencedBy: [],
    sources: ["5_RESTING"],
    metadata: {},
  },
  "Stealth": {
    id: "Stealth",
    name: ["Stealth"],
    allNames: ["Stealth"],
    type: "Skill Check",
    category: 'general',
    content: "Can you hide from it? — Calculated as **Mind** + **Reflex**.",
    refs: ['Mind', 'Reflex'],
    referencedBy: [],
    sources: ["3.1_STAT_CHECKS"],
    metadata: {"tags":"stat, skill, rollable","formula":"Mind + Reflex"},
  },
  "Strain": {
    id: "Strain",
    name: ["Strain"],
    allNames: ["Strain"],
    type: "term",
    category: 'general',
    content: "**Strain** represents accumulated fatigue and stress during combat. You gain **strain** from certain actions and abilities.",
    refs: [],
    referencedBy: ['A Good Night’s Rest (~6-8 hours of sleep)', 'Breather Action', 'Meal Break (~1 hour)', 'Snack Break (~15 minutes)', 'Strain Damage'],
    sources: [],
    metadata: {},
  },
  "Strain Damage": {
    id: "Strain Damage",
    name: ["Strain Damage"],
    allNames: ["Strain Damage"],
    type: "term",
    category: 'general',
    content: "At the end of combat, take 1 damage for every 2 **strain** accumulated (rounded down). This damage cannot be prevented by **resilience**.",
    refs: ['Resilience', 'Strain'],
    referencedBy: [],
    sources: [],
    metadata: {},
  },
  "Strength": {
    id: "Strength",
    name: ["Strength"],
    allNames: ["Strength"],
    type: "Skill Check",
    category: 'general',
    content: "Can you lift it? — Calculated as **Body** + **Body**.",
    refs: ['Body'],
    referencedBy: ['Body'],
    sources: ["3.1_STAT_CHECKS"],
    metadata: {"tags":"stat, skill, rollable","formula":"Body + Body"},
  },
  "Turn": {
    id: "Turn",
    name: ["Turn"],
    allNames: ["Turn"],
    type: "action",
    category: 'combat',
    content: "On your turn, you get a Complex Action and a Simple Action, or two Simple Actions.",
    refs: ['Complex Action', 'Simple Action'],
    referencedBy: ['Breather Action', 'Dodge Action', 'Instant Action'],
    sources: ["4_COMBAT"],
    metadata: {},
  }
} as const satisfies Record<GlossaryId, GlossaryEntry>;

export const GLOSSARY_LOOKUP: Record<string, GlossaryId> = {
  "a good night’s rest (~6-8 hours of sleep)": "A Good Night’s Rest (~6-8 hours of sleep)",
  "accuracy": "Accuracy",
  "acrobatics": "Acrobatics",
  "body": "Body",
  "breather action": "Breather Action",
  "cc": "Contested Check",
  "complex": "Complex Action",
  "complex action": "Complex Action",
  "contested check": "Contested Check",
  "critical fumble": "Critical Fumble",
  "dc": "Difficulty Check",
  "difficulty check": "Difficulty Check",
  "dodge": "Dodge",
  "dodge action": "Dodge Action",
  "flinch action": "Flinch Action",
  "full rest": "A Good Night’s Rest (~6-8 hours of sleep)",
  "fumble": "Fumble",
  "good night's rest": "A Good Night’s Rest (~6-8 hours of sleep)",
  "good night’s rest": "A Good Night’s Rest (~6-8 hours of sleep)",
  "health": "Health Points",
  "health points": "Health Points",
  "hit": "Hit",
  "hp": "Health Points",
  "instant": "Instant Action",
  "instant action": "Instant Action",
  "knowledge": "Knowledge",
  "meal break": "Meal Break (~1 hour)",
  "meal break (~1 hour)": "Meal Break (~1 hour)",
  "mind": "Mind",
  "movement": "Movement Speed",
  "movement speed": "Movement Speed",
  "pc": "Proficiency Check",
  "perception": "Perception",
  "proficiency check": "Proficiency Check",
  "reflex": "Reflex",
  "resilience": "Resilience",
  "resilience check": "Resilience Check",
  "simple": "Simple Action",
  "simple action": "Simple Action",
  "snack break": "Snack Break (~15 minutes)",
  "snack break (~15 minutes)": "Snack Break (~15 minutes)",
  "stealth": "Stealth",
  "strain": "Strain",
  "strain damage": "Strain Damage",
  "strength": "Strength",
  "turn": "Turn"
} as const
